export interface PerformanceScores {
    first_contentful_paint: number;
    first_meaningful_paint: number;
    time_to_interactive: number;
    largest_contentful_paint?: number;
    speed_index?: number;
    total_blocking_time?: number;
    cumulative_layout_shift?: number;
}

export interface PageData {
    id: number;
    domain_id: number;
    title: string;
    url: string;
    lastcheck: string;
    performance_scores?: PerformanceScores;
}

export interface ScoresData {
    profile_id: number;
    scanned_at: string;
    performance: number;
    version: string;
    first_meaningful_paint: number;
    first_contentful_paint: number;
    largest_contentful_paint: number;
    speed_index: number;
    total_blocking_time: number;
    cumulative_layout_shift: number;
}

export interface PagePerformanceAssignedProfileAttributes {
    id?: number;
    default_profile_id?: number;
    profile_ids?: number[];
    domain_id?: number;
    scan_frequency?: number;
    screenshot?: string;
    created_at?: string;
    updated_at?: string;
    scores?: ScoresData;
    page?: PageData;
}

export class PagePerformanceAssignedProfile {
    id: number = 0;
    default_profile_id: number = 0;
    profile_ids: number[] = [];
    domain_id: number = 0;
    scan_frequency?: number;
    screenshot?: string;
    created_at: string = '';
    updated_at: string = '';
    scores?: ScoresData;
    page?: PageData | null;

    constructor (attributes?: PagePerformanceAssignedProfileAttributes) {
        if (
            attributes && (
                attributes.page === null ||
                attributes.page?.performance_scores === null
            )
        ) {
            attributes.page = attributes.page || {};
            attributes.page.performance_scores = {
                first_contentful_paint: 0,
                first_meaningful_paint: 0,
                time_to_interactive: 0,
            };
        }
        Object.assign(this, attributes);
    }
}
